import { memo } from "react";
import { CalendarCheck } from "lucide-react";
import type { BotezBokehTemplateProps } from "./types";
import { CORAL_TEXT_LARGE, FONT_BODY, FONT_KICKER, FONT_SCRIPT, MUTED_TEXT, TEAL, TEAL_DARK, isRsvpCutoffPassed } from "./utils";

/**
 * RSVP section: a CTA that opens the shared PublicRsvpForm dialog through
 * onRsvpClick (wired in BotezBokehTemplate). The prototype's own inline form
 * is intentionally not ported (rule 3).
 */
export const BotezBokehRSVP = memo(({ event, config, t, onRsvpClick }: BotezBokehTemplateProps) => {
  // JUB-23: hide the section entirely when RSVP is disabled or the cutoff passed
  if (!event.rsvpSettings?.rsvpEnabled || isRsvpCutoffPassed(event)) {
    return null;
  }

  return (
    <section id="rsvp" className="relative z-10 py-16" style={{ background: config.palette.background }}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
        <h2
          className="text-4xl sm:text-5xl mb-6"
          style={{ fontFamily: FONT_SCRIPT, color: CORAL_TEXT_LARGE }}
        >
          {t("events.form.template.kindlyRespond")}
        </h2>
        <p
          className="text-base mb-10 break-words"
          style={{ fontFamily: FONT_BODY, color: MUTED_TEXT }}
        >
          {t("events.form.rsvpDescription")}
        </p>
        <button
          type="button"
          onClick={() => {
            if (onRsvpClick) {
              onRsvpClick();
            }
          }}
          className="inline-flex items-center gap-3 px-12 py-5 rounded-full text-white text-sm uppercase tracking-[0.15em] transition-all duration-300 motion-safe:hover:scale-105 shadow-lg font-medium"
          style={{ fontFamily: FONT_KICKER, backgroundColor: TEAL }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = TEAL_DARK)}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = TEAL)}
        >
          <CalendarCheck className="h-5 w-5" aria-hidden="true" />
          {t("events.form.template.rsvpToWedding")}
        </button>
      </div>
    </section>
  );
});

BotezBokehRSVP.displayName = "BotezBokehRSVP";
